import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CONSTANT_APIS} from "@shared/constant";

@Injectable({
  providedIn: 'root'
})
export class CreateStoreService {
  constructor(private http: HttpClient) {
  }

  public createStore(id: string, store: any) {
    return this.http.put(CONSTANT_APIS.CREATE_STORE.replace('id', id), store);
  }

  public validateStoreName(name: string) {
    return this.http.get(CONSTANT_APIS.VALIDATE_STORE + '?storeName=' + name);
  }

  public acceptProviderInvitation(id: string, body: any) {
    return this.http.put(CONSTANT_APIS.PROVIDER_ACCEPT_INVITATION.replace(':id', id), body);
  }
}
